import { InnoveraIcon } from "@libs/zapi-ui/assets";
import { Link } from "react-router-dom";
import { getRouteProjects } from "@/zapi-frontend/shared/const/router";

export function HeaderLogo() {
  return (
    <div className="-ml-4 shrink-0 border-r border-innoveraZinc-100 p-2">
      <Link
        data-testid="header-logo-link"
        to={getRouteProjects()}
        className="w-10 h-10 inline-flex justify-center items-center [&_svg>path]:hover:fill-innoveraOrange-400 [&_svg>path]:transition-[fill] [&_svg>path]:duration-[3ms]"
      >
        <InnoveraIcon className="w-6 h-6" />
      </Link>
    </div>
  );
}
